import { init as initTracking } from "@/services/tracking";

initTracking();
